export default __webpack_public_path__ + "static/media/green_frog.d0b24134.svg";